module.exports = __webpack_public_path__ + "static/young-mark-9de3527c68a40d169af6068fd4b71322.jpg";